import { AppDefaultState } from '@/store/app/state';
import { AuthDefaultState } from '@/store/auth/state';

export const DefaultState = {
  app: {
    ...AppDefaultState(),
    ...AuthDefaultState(),
  },
};
